import { CompanyService } from "../../../services/CompanyService";

const getSubAccountCountUsingLcPhone = async function ({ commit, dispatch, state }, config) {
    const { companyId } = config
    
    try {
        const data = await CompanyService.getSubAccountCountUsingLcPhone(companyId);
        return data;
    } catch (error) {
        console.error(error);
    }
};

export default getSubAccountCountUsingLcPhone;